import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import type { CompanyLogo } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";
import { deleteCompanyLogo } from "../api/deleteCompanyLogo";

export const useDeleteCompanyLogo = (): UseMutationResult<
  ApiResponse<CompanyLogo>,
  ApiError,
  void
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCompanyLogo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: withPrefix(["company"]) });
    },
  });
};
